import axios from 'axios';

export async function uploadImageWithProgress({
  file,
  listingID,
  onProgress,
}: {
  file: File;
  listingID: number;
  onProgress: (percent: number) => void;
}) {
  const mutation = `
    mutation updateLisingImage($file: Upload!, $listingID: Int!) {
      updateLisingImage(file: $file, listingID: $listingID)
    }
  `;

  const form = new FormData();
  form.append(
    'operations',
    JSON.stringify({
      query: mutation,
      variables: {
        file: null,
        listingID: listingID,
      },
    })
  );

  form.append('map', JSON.stringify({ '0': ['variables.file'] }));
  form.append('0', file);

  const response = await axios.post(`${process.env.NEXT_PUBLIC_API_ENDPOINT!}`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: (progressEvent) => {
      const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      onProgress(percent);
    },
  });

  return response.data;
}
